// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/accounts.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { DateSchedule } from "../../optimizer/v1/date_schedule";
import { Date } from "./date";
/**
 * @generated from protobuf message core.v1.RRSPAccount
 */
export interface RRSPAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string; // identifier
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string; // optional, placeholder label if empty
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: core.v1.RegisteredAccountType type = 4;
     */
    type: RegisteredAccountType;
    /**
     * @generated from protobuf field: optional double mer = 5;
     */
    mer?: number;
    /**
     * @generated from protobuf field: optional double total_contribution = 6;
     */
    totalContribution?: number;
    /**
     * @generated from protobuf field: optional double current_year_contributed_amount = 7;
     */
    currentYearContributedAmount?: number;
    /**
     * @generated from protobuf field: core.v1.RRSPAccount.PlanType plan_type = 8;
     */
    planType: RRSPAccount_PlanType; // required (the defaults pass fills INDIVIDUAL on older documents)
}
/**
 * @generated from protobuf enum core.v1.RRSPAccount.PlanType
 */
export enum RRSPAccount_PlanType {
    /**
     * @generated from protobuf enum value: PLAN_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PLAN_TYPE_INDIVIDUAL = 1;
     */
    INDIVIDUAL = 1,
    /**
     * employer-sponsored
     *
     * @generated from protobuf enum value: PLAN_TYPE_GROUP = 2;
     */
    GROUP = 2
}
/**
 * @generated from protobuf message core.v1.TFSAAccount
 */
export interface TFSAAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: core.v1.RegisteredAccountType type = 4;
     */
    type: RegisteredAccountType;
    /**
     * @generated from protobuf field: optional double mer = 5;
     */
    mer?: number;
    /**
     * @generated from protobuf field: optional double total_contribution = 6;
     */
    totalContribution?: number;
    /**
     * @generated from protobuf field: optional double current_year_contributed_amount = 7;
     */
    currentYearContributedAmount?: number;
}
/**
 * @generated from protobuf message core.v1.FHSAAccount
 */
export interface FHSAAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: core.v1.RegisteredAccountType type = 4;
     */
    type: RegisteredAccountType;
    /**
     * @generated from protobuf field: optional double mer = 5;
     */
    mer?: number;
    /**
     * @generated from protobuf field: optional double total_contribution = 6;
     */
    totalContribution?: number;
    /**
     * @generated from protobuf field: optional double current_year_contributed_amount = 7;
     */
    currentYearContributedAmount?: number;
    /**
     * @generated from protobuf field: core.v1.Date opened_date = 8;
     */
    openedDate?: Date; // the 15-year participation period starts here
    /**
     * @generated from protobuf field: optional double withheld_tax_owing = 9;
     */
    withheldTaxOwing?: number;
    /**
     * The household confirmed this FHSA is to be moved to the RRSP because its holder isn't a first-time home
     * buyer (Person.is_first_time_home_buyer false): saves stop asking (FieldError.CODE_FHSA_TRANSFER_UNCONFIRMED)
     * and the plan's transfer says so (TransferFhsaToRrspAction.REASON_NOT_FIRST_TIME_BUYER_CONFIRMED).
     *
     * @generated from protobuf field: bool transfer_to_rrsp_confirmed = 10;
     */
    transferToRrspConfirmed: boolean;
}
/**
 * Registered Retirement Income Fund. Created from an RRSP (by age 71 at the latest).
 *
 * @generated from protobuf message core.v1.RRIFAccount
 */
export interface RRIFAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: optional double mer = 4;
     */
    mer?: number;
    /**
     * @generated from protobuf field: core.v1.Date opened_date = 5;
     */
    openedDate?: Date;
    /**
     * @generated from protobuf field: optional double withdrawn_this_year = 6;
     */
    withdrawnThisYear?: number; // the minimum withdrawal is computed by the engine
    /**
     * @generated from protobuf field: string source_rrsp_uuid = 7;
     */
    sourceRrspUuid: string;
}
/**
 * @generated from protobuf message core.v1.RESPAccount
 */
export interface RESPAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: optional double interest_apr = 4;
     */
    interestApr?: number;
    /**
     * @generated from protobuf field: core.v1.RESPAccount.PlanType plan_type = 5;
     */
    planType: RESPAccount_PlanType;
    /**
     * @generated from protobuf field: optional double total_contribution = 6;
     */
    totalContribution?: number;
    /**
     * @generated from protobuf field: optional double contribution_this_year = 7;
     */
    contributionThisYear?: number;
    /**
     * @generated from protobuf field: optional double total_clb = 8;
     */
    totalClb?: number;
    /**
     * @generated from protobuf field: optional double total_cesg = 9;
     */
    totalCesg?: number;
    /**
     * @generated from protobuf field: core.v1.Date creation_date = 10;
     */
    creationDate?: Date;
    /**
     * @generated from protobuf field: repeated string beneficiary_uuids = 11;
     */
    beneficiaryUuids: string[]; // Dependent uuids
    /**
     * @generated from protobuf field: optional double cesg_unused_room_prior_years = 12;
     */
    cesgUnusedRoomPriorYears?: number;
    /**
     * @generated from protobuf field: optional double cesg_received_this_year = 13;
     */
    cesgReceivedThisYear?: number;
    /**
     * @generated from protobuf field: optional double eap_withdrawn = 14;
     */
    eapWithdrawn?: number; // educational assistance payments to date
}
/**
 * @generated from protobuf enum core.v1.RESPAccount.PlanType
 */
export enum RESPAccount_PlanType {
    /**
     * @generated from protobuf enum value: PLAN_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PLAN_TYPE_FAMILY = 1;
     */
    FAMILY = 1,
    /**
     * @generated from protobuf enum value: PLAN_TYPE_INDIVIDUAL = 2;
     */
    INDIVIDUAL = 2
}
/**
 * @generated from protobuf message core.v1.ChequingAccount
 */
export interface ChequingAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: optional double interest_apr = 4;
     */
    interestApr?: number;
    /**
     * @generated from protobuf field: core.v1.ChequingAccount.Type type = 5;
     */
    type: ChequingAccount_Type;
    /**
     * @generated from protobuf field: core.v1.Provider provider = 6;
     */
    provider: Provider;
    /**
     * @generated from protobuf field: core.v1.Date last_known_accruement_date = 8;
     */
    lastKnownAccruementDate?: Date;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule accruement_schedule = 9;
     */
    accruementSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: core.v1.ChequingAccount.EmergencyFund emergency_fund = 10;
     */
    emergencyFund?: ChequingAccount_EmergencyFund;
}
/**
 * The part of this account the household treats as its emergency fund (prototype onboarding
 * "Your safety net"). Unset = not an emergency fund.
 *
 * @generated from protobuf message core.v1.ChequingAccount.EmergencyFund
 */
export interface ChequingAccount_EmergencyFund {
    /**
     * @generated from protobuf field: bool whole_balance = 1;
     */
    wholeBalance: boolean;
    /**
     * @generated from protobuf field: optional double amount = 2;
     */
    amount?: number; // when not the whole balance
}
/**
 * @generated from protobuf enum core.v1.ChequingAccount.Type
 */
export enum ChequingAccount_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CHEQUING = 1;
     */
    CHEQUING = 1,
    /**
     * @generated from protobuf enum value: TYPE_SAVINGS = 2;
     */
    SAVINGS = 2,
    /**
     * @generated from protobuf enum value: TYPE_OTHER = 3;
     */
    OTHER = 3
}
/**
 * @generated from protobuf message core.v1.NonRegisteredInvestmentAccount
 */
export interface NonRegisteredInvestmentAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: optional double mer = 4;
     */
    mer?: number;
    /**
     * @generated from protobuf field: core.v1.Date last_known_accruement_date = 6;
     */
    lastKnownAccruementDate?: Date;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule accruement_schedule = 7;
     */
    accruementSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: optional double adjusted_cost_base = 8;
     */
    adjustedCostBase?: number; // total ACB of the holdings; capital gains are measured against it
    /**
     * @generated from protobuf field: optional double units = 9;
     */
    units?: number; // units held, for proportional ACB on partial sales
}
/**
 * Defined Contribution pension balance (accumulating while employed, or converted after retirement).
 *
 * @generated from protobuf message core.v1.DCPensionAccount
 */
export interface DCPensionAccount {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: optional double current_value = 3;
     */
    currentValue?: number;
    /**
     * @generated from protobuf field: optional double mer = 4;
     */
    mer?: number;
    /**
     * @generated from protobuf field: optional double total_contributions = 5;
     */
    totalContributions?: number;
    /**
     * @generated from protobuf field: optional double employee_contributions = 6;
     */
    employeeContributions?: number;
    /**
     * @generated from protobuf field: optional double employer_contributions = 7;
     */
    employerContributions?: number;
    /**
     * @generated from protobuf field: optional string source_pension_uuid = 8;
     */
    sourcePensionUuid?: string;
    /**
     * @generated from protobuf field: int32 accruement_period_in_days = 9;
     */
    accruementPeriodInDays: number;
    /**
     * @generated from protobuf field: core.v1.Date last_known_accruement_date = 10;
     */
    lastKnownAccruementDate?: Date;
    /**
     * @generated from protobuf field: optional double withdrawn_this_year = 11;
     */
    withdrawnThisYear?: number;
}
// Balances are facts as of Family.facts_as_of (or their field_sources as_of). Schedule anchors are
// the last known occurrence, never the next one, so a stored family never goes stale
// (architecture-redesign.md item J §3).

/**
 * @generated from protobuf enum core.v1.RegisteredAccountType
 */
export enum RegisteredAccountType {
    /**
     * @generated from protobuf enum value: REGISTERED_ACCOUNT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REGISTERED_ACCOUNT_TYPE_MUTUAL_FUND = 1;
     */
    MUTUAL_FUND = 1,
    /**
     * @generated from protobuf enum value: REGISTERED_ACCOUNT_TYPE_ETF = 2;
     */
    ETF = 2,
    /**
     * @generated from protobuf enum value: REGISTERED_ACCOUNT_TYPE_GIC = 3;
     */
    GIC = 3,
    /**
     * @generated from protobuf enum value: REGISTERED_ACCOUNT_TYPE_SELF_DIRECTED = 4;
     */
    SELF_DIRECTED = 4,
    /**
     * @generated from protobuf enum value: REGISTERED_ACCOUNT_TYPE_OTHER = 5;
     */
    OTHER = 5
}
/**
 * @generated from protobuf enum core.v1.Provider
 */
export enum Provider {
    /**
     * @generated from protobuf enum value: PROVIDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PROVIDER_RBC = 1;
     */
    RBC = 1,
    /**
     * @generated from protobuf enum value: PROVIDER_TD = 2;
     */
    TD = 2,
    /**
     * @generated from protobuf enum value: PROVIDER_SCOTIABANK = 3;
     */
    SCOTIABANK = 3,
    /**
     * @generated from protobuf enum value: PROVIDER_BMO = 4;
     */
    BMO = 4,
    /**
     * @generated from protobuf enum value: PROVIDER_CIBC = 5;
     */
    CIBC = 5,
    /**
     * @generated from protobuf enum value: PROVIDER_NATIONAL_BANK = 6;
     */
    NATIONAL_BANK = 6,
    /**
     * @generated from protobuf enum value: PROVIDER_OTHER = 7;
     */
    OTHER = 7
}
/**
 * @generated from protobuf enum core.v1.AccountType
 */
export enum AccountType {
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_CHEQUING_ACCOUNT = 1;
     */
    CHEQUING_ACCOUNT = 1,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_RRSP_ACCOUNT = 2;
     */
    RRSP_ACCOUNT = 2,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_TFSA_ACCOUNT = 3;
     */
    TFSA_ACCOUNT = 3,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_NON_REGISTERED_INVESTMENT_ACCOUNT = 4;
     */
    NON_REGISTERED_INVESTMENT_ACCOUNT = 4,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_RESP_ACCOUNT = 5;
     */
    RESP_ACCOUNT = 5,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_FHSA_ACCOUNT = 6;
     */
    FHSA_ACCOUNT = 6,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_DC_PENSION_ACCOUNT = 7;
     */
    DC_PENSION_ACCOUNT = 7,
    /**
     * @generated from protobuf enum value: ACCOUNT_TYPE_RRIF_ACCOUNT = 8;
     */
    RRIF_ACCOUNT = 8
}
// @generated message type with reflection information, may provide speed optimized methods
class RRSPAccount$Type extends MessageType<RRSPAccount> {
    constructor() {
        super("core.v1.RRSPAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["core.v1.RegisteredAccountType", RegisteredAccountType, "REGISTERED_ACCOUNT_TYPE_"] },
            { no: 5, name: "mer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "current_year_contributed_amount", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "plan_type", kind: "enum", T: () => ["core.v1.RRSPAccount.PlanType", RRSPAccount_PlanType, "PLAN_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RRSPAccount
 */
export const RRSPAccount = new RRSPAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TFSAAccount$Type extends MessageType<TFSAAccount> {
    constructor() {
        super("core.v1.TFSAAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["core.v1.RegisteredAccountType", RegisteredAccountType, "REGISTERED_ACCOUNT_TYPE_"] },
            { no: 5, name: "mer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "current_year_contributed_amount", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.TFSAAccount
 */
export const TFSAAccount = new TFSAAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FHSAAccount$Type extends MessageType<FHSAAccount> {
    constructor() {
        super("core.v1.FHSAAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["core.v1.RegisteredAccountType", RegisteredAccountType, "REGISTERED_ACCOUNT_TYPE_"] },
            { no: 5, name: "mer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "current_year_contributed_amount", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "opened_date", kind: "message", T: () => Date },
            { no: 9, name: "withheld_tax_owing", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "transfer_to_rrsp_confirmed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.FHSAAccount
 */
export const FHSAAccount = new FHSAAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RRIFAccount$Type extends MessageType<RRIFAccount> {
    constructor() {
        super("core.v1.RRIFAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "mer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "opened_date", kind: "message", T: () => Date },
            { no: 6, name: "withdrawn_this_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "source_rrsp_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RRIFAccount
 */
export const RRIFAccount = new RRIFAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RESPAccount$Type extends MessageType<RESPAccount> {
    constructor() {
        super("core.v1.RESPAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "interest_apr", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "plan_type", kind: "enum", T: () => ["core.v1.RESPAccount.PlanType", RESPAccount_PlanType, "PLAN_TYPE_"] },
            { no: 6, name: "total_contribution", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "contribution_this_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "total_clb", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "total_cesg", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "creation_date", kind: "message", T: () => Date },
            { no: 11, name: "beneficiary_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "cesg_unused_room_prior_years", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "cesg_received_this_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "eap_withdrawn", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RESPAccount
 */
export const RESPAccount = new RESPAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChequingAccount$Type extends MessageType<ChequingAccount> {
    constructor() {
        super("core.v1.ChequingAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "interest_apr", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "type", kind: "enum", T: () => ["core.v1.ChequingAccount.Type", ChequingAccount_Type, "TYPE_"] },
            { no: 6, name: "provider", kind: "enum", T: () => ["core.v1.Provider", Provider, "PROVIDER_"] },
            { no: 8, name: "last_known_accruement_date", kind: "message", T: () => Date },
            { no: 9, name: "accruement_schedule", kind: "message", T: () => DateSchedule },
            { no: 10, name: "emergency_fund", kind: "message", T: () => ChequingAccount_EmergencyFund }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ChequingAccount
 */
export const ChequingAccount = new ChequingAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChequingAccount_EmergencyFund$Type extends MessageType<ChequingAccount_EmergencyFund> {
    constructor() {
        super("core.v1.ChequingAccount.EmergencyFund", [
            { no: 1, name: "whole_balance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "amount", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ChequingAccount.EmergencyFund
 */
export const ChequingAccount_EmergencyFund = new ChequingAccount_EmergencyFund$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NonRegisteredInvestmentAccount$Type extends MessageType<NonRegisteredInvestmentAccount> {
    constructor() {
        super("core.v1.NonRegisteredInvestmentAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "mer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "last_known_accruement_date", kind: "message", T: () => Date },
            { no: 7, name: "accruement_schedule", kind: "message", T: () => DateSchedule },
            { no: 8, name: "adjusted_cost_base", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "units", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.NonRegisteredInvestmentAccount
 */
export const NonRegisteredInvestmentAccount = new NonRegisteredInvestmentAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DCPensionAccount$Type extends MessageType<DCPensionAccount> {
    constructor() {
        super("core.v1.DCPensionAccount", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_value", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "mer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "total_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "employee_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "employer_contributions", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "source_pension_uuid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "accruement_period_in_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "last_known_accruement_date", kind: "message", T: () => Date },
            { no: 11, name: "withdrawn_this_year", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DCPensionAccount
 */
export const DCPensionAccount = new DCPensionAccount$Type();
